/**
 * Возвращает параметры, которые были в старой строке запроса и пропали в новой.
 * Строки передаются без ведущего «?».
 *
 * Такой же лейбл шлёт микрофронт фильтров для своих тегов, поэтому логика повторяет его.
 */
export function getRemovedQueryParams(oldQueryString: string, newQueryString: string): string {
  const oldParams = new URLSearchParams(oldQueryString);
  const newParams = new URLSearchParams(newQueryString);
  const removedParams = new URLSearchParams();

  oldParams.forEach((value, key) => {
    if (!newParams.has(key)) {
      removedParams.append(key, value);
    }
  });

  return removedParams.toString();
}
